var React = require('react');

function FacebookIconSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.5 0c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062v11c0 .417-.146.77-.438 1.063A1.446 1.446 0 0112.5 14H8.219V9.25h1.812L10.375 7H8.219V5.531c0-.791.416-1.187 1.25-1.187h.969V2.437a9.765 9.765 0 00-1.72-.156c-.603 0-1.124.115-1.562.344-.416.23-.75.573-1 1.031-.25.459-.375 1-.375 1.625V7H3.813v2.25H5.78V14H1.5c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 010 12.5v-11C0 1.083.146.73.438.437A1.447 1.447 0 011.5 0h11z","fill":"#fff"}));
}

FacebookIconSmall.defaultProps = {"width":"14","height":"14","fill":"none"};

module.exports = FacebookIconSmall;

FacebookIconSmall.default = FacebookIconSmall;
